import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "You though computer science has no place in webdev? Here's a fun coding challenge",
  "description": "",
  "published": "2020-08-21T00:00:00.000Z",
  "redirect_from": ["/blog/you-though-computer-science-has-no-place-in-webdev-heres-a-fun-coding-challenge/swizec/9484"],
  "categories": "Computer Science, Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1598025292053.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Friend, you don't often get to show off your leetcode skills at work. They get you through the whiteboard interview and vanish forever.`}</p>
    <p>{`Yesterday I ran into a rare challenge that let me use those skills. Thought I'd share ✌️`}</p>
    <p>{`You've got this string of buggy JSX.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%20%20%20%20%3Cdiv%20data-prop%3D%22hello%22%20ref%3D%22%7Bthis.refCallback%7D%22%20id%3D%22an-id%22%20style%3D%22%7B%7B%22%20border%3A%3D%22%22%20%26%2334%3B1px%3D%22%22%20solid%3D%22%22%20red%26%2334%3B%3D%22%22%20%7D%7D%3D%22%22%20keepme%3D%22%7Blol%7D%22%20href%3D%22a%20link%22%20objprop%3D%22%7B%7Btest%3A%26%2339%3Bnospace%26%2339%3B%7D%7D%22%20objprop2%3D%22%7B%7B%22%20test%3A%3D%22%22%20%26%2339%3Bleftspace%26%2339%3B%7D%7D%3D%22%22%20notobj%3D%22%7B%7B%22%3E%0A%20%20%20%20%20%20%20%20%7Bfaker.lorem.paragraphs(Math.random()%20*%2010)%7D%0A%20%20%20%20%20%20%3C%2Fdiv%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "25.112107623318387%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'101\\'%20viewBox=\\'0%200%20400%20101\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2024v57c1%203%20373%203%20374%200V19H13v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/762b56a7332ab3ad369427b49f9b356d/ca0a1/techletter.app-screenshot-1598025292053.webp 223w", "/static/762b56a7332ab3ad369427b49f9b356d/75680/techletter.app-screenshot-1598025292053.webp 445w", "/static/762b56a7332ab3ad369427b49f9b356d/8d1ba/techletter.app-screenshot-1598025292053.webp 890w", "/static/762b56a7332ab3ad369427b49f9b356d/3838e/techletter.app-screenshot-1598025292053.webp 1335w", "/static/762b56a7332ab3ad369427b49f9b356d/e11e5/techletter.app-screenshot-1598025292053.webp 1780w", "/static/762b56a7332ab3ad369427b49f9b356d/8df42/techletter.app-screenshot-1598025292053.webp 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/762b56a7332ab3ad369427b49f9b356d/e92b6/techletter.app-screenshot-1598025292053.png 223w", "/static/762b56a7332ab3ad369427b49f9b356d/e66bf/techletter.app-screenshot-1598025292053.png 445w", "/static/762b56a7332ab3ad369427b49f9b356d/4ef49/techletter.app-screenshot-1598025292053.png 890w", "/static/762b56a7332ab3ad369427b49f9b356d/4e814/techletter.app-screenshot-1598025292053.png 1335w", "/static/762b56a7332ab3ad369427b49f9b356d/701e9/techletter.app-screenshot-1598025292053.png 1780w", "/static/762b56a7332ab3ad369427b49f9b356d/a878e/techletter.app-screenshot-1598025292053.png 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/762b56a7332ab3ad369427b49f9b356d/4ef49/techletter.app-screenshot-1598025292053.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`JSX confused an HTML parser–stringifier and this is what happened. You can't put it back through a parser because now it's neither valid HTML nor valid JSX. 😅`}</p>
    <p>{`Here's the data model – part of an abstract syntax tree – that produces the above result:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%20%20%7B%0A%20%20%20%20%20%20type%3A%20'element'%2C%0A%20%20%20%20%20%20tagName%3A%20'div'%2C%0A%20%20%20%20%20%20properties%3A%20%7B%0A%20%20%20%20%20%20%20%20dataProp%3A%20'hello'%2C%0A%20%20%20%20%20%20%20%20ref%3A%20'%7Bthis.refCallback%7D'%2C%0A%20%20%20%20%20%20%20%20id%3A%20'an-id'%2C%0A%20%20%20%20%20%20%20%20style%3A%20'%7B%7B'%2C%0A%20%20%20%20%20%20%20%20'border%3A'%3A%20''%2C%0A%20%20%20%20%20%20%20%20'%221px'%3A%20''%2C%0A%20%20%20%20%20%20%20%20solid%3A%20''%2C%0A%20%20%20%20%20%20%20%20'red%22'%3A%20''%2C%0A%20%20%20%20%20%20%20%20'%7D%7D'%3A%20''%2C%0A%20%20%20%20%20%20%20%20keepme%3A%20'%7Blol%7D'%2C%0A%20%20%20%20%20%20%20%20href%3A%20'a%20link'%2C%0A%20%20%20%20%20%20%20%20objprop%3A%20%22%7B%7Btest%3A'nospace'%7D%7D%22%2C%0A%20%20%20%20%20%20%20%20objprop2%3A%20'%7B%7B'%2C%0A%20%20%20%20%20%20%20%20'test%3A'%3A%20''%2C%0A%20%20%20%20%20%20%20%20%22'leftspace'%7D%7D%22%3A%20''%2C%0A%20%20%20%20%20%20%20%20notobj%3A%20'%7B%7B'%0A%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20children%3A%20%5B%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20type%3A%20'text'%2C%0A%20%20%20%20%20%20%20%20%20%20value%3A%20'%5Cn%20%20%20%20%20%20%20%20%7Bfaker.lorem.paragraphs(Math.random()%20*%2010)%7D%5Cn%20%20%20%20%20%20'%2C%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%5D%0A%20%20%20%20%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "88.78923766816143%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'355\\'%20viewBox=\\'0%200%20400%20355\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M18%2027a8742%208742%200%20001%20303h363l1-152V27l-183-1-182%201M0%20350v5h401v-11H0v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8851374427a640d7fe091b23c0a9b65f/ca0a1/techletter.app-screenshot-1598025292105.webp 223w", "/static/8851374427a640d7fe091b23c0a9b65f/75680/techletter.app-screenshot-1598025292105.webp 445w", "/static/8851374427a640d7fe091b23c0a9b65f/8d1ba/techletter.app-screenshot-1598025292105.webp 890w", "/static/8851374427a640d7fe091b23c0a9b65f/3838e/techletter.app-screenshot-1598025292105.webp 1335w", "/static/8851374427a640d7fe091b23c0a9b65f/dde0f/techletter.app-screenshot-1598025292105.webp 1516w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8851374427a640d7fe091b23c0a9b65f/e92b6/techletter.app-screenshot-1598025292105.png 223w", "/static/8851374427a640d7fe091b23c0a9b65f/e66bf/techletter.app-screenshot-1598025292105.png 445w", "/static/8851374427a640d7fe091b23c0a9b65f/4ef49/techletter.app-screenshot-1598025292105.png 890w", "/static/8851374427a640d7fe091b23c0a9b65f/4e814/techletter.app-screenshot-1598025292105.png 1335w", "/static/8851374427a640d7fe091b23c0a9b65f/a8a6f/techletter.app-screenshot-1598025292105.png 1516w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8851374427a640d7fe091b23c0a9b65f/4ef49/techletter.app-screenshot-1598025292105.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And here's the output you want:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%3Cdiv%20data-prop%3D%22hello%22%20ref%3D%7Bthis.refCallback%7D%20id%3D%22an-id%22%20style%3D%7B%7B%20border%3A%20%221px%20solid%20red%22%20%7D%7D%20keepme%3D%7Blol%7D%20href%3D%22a%20link%22%20objprop%3D%7B%7Btest%3A'nospace'%7D%7D%20objprop2%3D%7B%7B%20test%3A%20'leftspace'%7D%7D%3E%0A%20%20%20%20%7Bfaker.lorem.paragraphs(Math.random()%20*%2010)%7D%0A%20%20%3C%2Fdiv%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "23.318385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'94\\'%20viewBox=\\'0%200%20400%2094\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2024v50c1%203%20373%203%20374%200V19H13v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/acdbc9fd7bc698e5da36bc94734a46f1/ca0a1/techletter.app-screenshot-1598025292011.webp 223w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/75680/techletter.app-screenshot-1598025292011.webp 445w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/8d1ba/techletter.app-screenshot-1598025292011.webp 890w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/3838e/techletter.app-screenshot-1598025292011.webp 1335w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/e11e5/techletter.app-screenshot-1598025292011.webp 1780w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/8df42/techletter.app-screenshot-1598025292011.webp 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/acdbc9fd7bc698e5da36bc94734a46f1/e92b6/techletter.app-screenshot-1598025292011.png 223w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/e66bf/techletter.app-screenshot-1598025292011.png 445w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/4ef49/techletter.app-screenshot-1598025292011.png 890w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/4e814/techletter.app-screenshot-1598025292011.png 1335w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/701e9/techletter.app-screenshot-1598025292011.png 1780w", "/static/acdbc9fd7bc698e5da36bc94734a46f1/a878e/techletter.app-screenshot-1598025292011.png 2048w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/acdbc9fd7bc698e5da36bc94734a46f1/4ef49/techletter.app-screenshot-1598025292011.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The tools to stringify your AST exist 👉 `}<inlineCode parentName="p">{`toHTML(tree)`}</inlineCode></p>
    <p>{`But you need to:`}</p>
    <ol>
      <li parentName="ol">{`avoid quotes around JSX props denoted by `}<inlineCode parentName="li">{`{}`}</inlineCode></li>
      <li parentName="ol">{`avoid breaking JSX object props denoted by `}<inlineCode parentName="li">{`{{ }}`}</inlineCode></li>
    </ol>
    <p>{`Looks like the parser takes every space as a new attribute. The stringifier wraps every attribute in quotes.`}</p>
    <p>{`Have fun ❤️`}</p>
    <p>{`Here's a codesandbox I prepared, if you want to play around.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/agitated-drake-9kclq"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-9h96l1%205%202%204%201-98V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9bcb7d70c499b1fe16334fcf460195f1/ca0a1/techletter.app-screenshot-1598025319641.webp 223w", "/static/9bcb7d70c499b1fe16334fcf460195f1/75680/techletter.app-screenshot-1598025319641.webp 445w", "/static/9bcb7d70c499b1fe16334fcf460195f1/8d1ba/techletter.app-screenshot-1598025319641.webp 890w", "/static/9bcb7d70c499b1fe16334fcf460195f1/3838e/techletter.app-screenshot-1598025319641.webp 1335w", "/static/9bcb7d70c499b1fe16334fcf460195f1/e11e5/techletter.app-screenshot-1598025319641.webp 1780w", "/static/9bcb7d70c499b1fe16334fcf460195f1/0a0f4/techletter.app-screenshot-1598025319641.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9bcb7d70c499b1fe16334fcf460195f1/e92b6/techletter.app-screenshot-1598025319641.png 223w", "/static/9bcb7d70c499b1fe16334fcf460195f1/e66bf/techletter.app-screenshot-1598025319641.png 445w", "/static/9bcb7d70c499b1fe16334fcf460195f1/4ef49/techletter.app-screenshot-1598025319641.png 890w", "/static/9bcb7d70c499b1fe16334fcf460195f1/4e814/techletter.app-screenshot-1598025319641.png 1335w", "/static/9bcb7d70c499b1fe16334fcf460195f1/701e9/techletter.app-screenshot-1598025319641.png 1780w", "/static/9bcb7d70c499b1fe16334fcf460195f1/bb052/techletter.app-screenshot-1598025319641.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9bcb7d70c499b1fe16334fcf460195f1/4ef49/techletter.app-screenshot-1598025319641.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Give it a shot before you read on, at least a little think.`}</p>
    <hr></hr>
    <p>{`Did you finish the challenge? Had fun?`}</p>
    <p>{`I did :P`}</p>
    <p><a parentName="p" {...{
        "href": "https://xkcd.com/356/"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "740px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50.224215246636774%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'201\\'%20viewBox=\\'0%200%20400%20201\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20101v100h94v-86l-47-1H1v-7h112V0H0v101m121-48l1%2054h88V0h-89v53m98%201v53h77V0h-77v54M1%2053v52h18a137%20137%200%200022-1c-1%201%208%201%2035%201h36V87l-1-19-3%202c-4%203-15%208-15%207l6-3%205-3-3-1c-2-2-3-1-6%200-4%203-4%203-4%207l1%206v4c0%203%200%203-2%201-2-1-2-1-2%201l-1%203v-3c-1-3-3-2-3%202l-1%202-1-2-1-3-1%202-1%201h-2c-2%201-2%201-2-1l2-4c0-2%201-3%202-3%202%200%202%200%200-2-2-1-2-2-1-2h3l1%201v-3c0-3%202-6%205-6%201%201%203%200%205-1%206-4%202-5-6-2l-2-1%203-2c2%200%202%200%201-1h-8l2-1v-1h-4c-2%200-3%200-2-1%204-3-1-2-13%202l-2-1%205-2c9-3%206-3-5-1h-4l26-5%2024-4c4-1%205-1%205-4v-3l-12-1c-11%200-12%200-12%202l-2%201-1%201-6%201a14951%2014951%200%2000-7-1c-2%200-2-1-1-3%201-5%201-6%203-6s2%200%202%205l-1%204h4l5-1v-2l-1-2c0-3%203-4%203-1%201%201%201%201%201-1s-1-2-2-2c-3%200-3%200-3%204%200%203%200%204-2%204-3%200-3-6%200-8%202-1%201-1-7-1l-11-1c-1%201-2%2011-1%2012%202%201-1%209-3%209v-4l1-5%201-7v-5a255%20255%200%2000-17%204v3c-1%202-1%203%201%203l1-1c0-1%201-2%202-1l1-2c0-2%200-2-1%200-1%201-1%201-1-1l2-2%201%204%201%204c1%200%202-1%202-4l1-4h4l-2%201c-1%200-2%200-2%203l1%203%201-3c1-3%201-3%201%200s0%204-2%204-2%200%201%201c7%202%202%202-7%200-7-2-15-5-11-5l2-5c0-4%201-5%203-6%203-2%203-2%201-2-5%201-3-1%202-2h13c9%201%209%201%207%204-3%202-2%203%209%203%2013%201%2014%202%2014%204%200%203%202%203%2014%203h10V1H1v52m121-22v30l3-1h3l-3%201-3%202v42h87V89h-13c-19-1-20-3-1-4h9l-12-1-12-1h9c13%200%2013-2%201-2l-10-1h9c10%200%2010%200%2014%203l4%203h-16l7%201h10l1-6v-7h-9c-8%200-8%200-6%202%203%202%201%203-8%202l-8-1h16l-7-1-8-2h10l-7-1c-6%200-6%200-6%202%200%204%201%209%202%208l1%201%201%204-1%203c-3-1-4%202-1%204l1%202%201-2v-3l1-1v8c-1%202-5-2-6-6-1-2-1-2-1%200v3l-1-1-1-3c-2-1-4%200-4%203l-1%201-1-1v-2a56%2056%200%20012-21c1-2%206-2%207%200%200%201%203-2%203-4v-3l1-5c0-3%201-4%204-3%203%200%203%205%200%206-1%200-2%201-2%203v3c-1%202%201%203%2016%204h12V63l-1-10v-1l1-25V1h-87v30m98-2v28h3l3%201h-3c-3%200-3%200-3%207v6h7l6%201h1c1-2%204-3%206-1s1%2010-1%2011c-2%200-3%202-1%207l1%203-2-3c-2-5-2-3-1%205l1%208-1-6c-1-5-2-4-4%201l-2%204%202-7c2-7%203-10%201-6l-2%201%202-5c2-2%202-4%201-4l-1-4c0-3-3-4-10-4h-3v16h10l-5%201h-5v16h75V74h-6c-6%200-6%200-6%203l-1%204%203%204%202%203h-4l-6%201h-1l-9-1h-9l1-1v-2c-1-2-2%201-2%209-1%207-2%2011-2%206%200-1%200-2-1-1l-1-1-1-2-1%202-1%202h-2c-2%203-3%202-2-1l-1-2v-2l1-5%201-4%201-4%201-4v-1l-1-3-1-5c-2-3-2-4-1-5l12-4a144%20144%200%20012%203l1-1v2c-1%201-1%202%201%205%202%205%203%204%202-2%200-3%202-6%205-4%202%202%201%205-1%206s0%203%207%203c7%201%207%200%205-4l-2-2c0-2%203%201%204%204s2%203%207%203h6v-9c0-11%200-11-8-11-5%200-5%200-2-14l1-8-1%207-1%2010c0%203%200%203%205%203h5l1-13V25h-4l-4-1h8v-8h-24l-23%201v8c0%207%200%208-1%205l-1-10v-5h49V1h-75v28M370%201l-33%201c-40%201-37%201-36%207l4%2073%201%208%205-1a4692%204692%200%200035%201l1%209%201%208V97l-1-9h8v6l1%2010c1%202%201-1%201-7l-1-9h41l-1-8-2-16-1-35V1h-23m-14%202l-37%202h-18v3a667%20667%200%20015%2072l1%208h14a472%20472%200%200055-2c21%201%2020%201%2019-6l-2-16c-2-9-2-14-2-36l1-26h-9l-27%201M43%208v3c0%202%200%202%203%202%202%200%203%200%202-1v-2c0-2%202-1%202%201%200%203%202%202%203%200s1-2%201%200%201%202%205%202l4-1h1c2%202%203%201%203-1l-1-3-1%201h-9c0-1-1-2-6-2l-7%201m32%209v3c0%202%202%204%202%202v-1l-1-2%202%201c1%202%206%203%206%201h2l14%201c2%200%201-4-1-5s-7%200-6%202l-1%201-1-1c0-2-6-2-8-1h-1c0-1-6-2-7-1m259%208l-1%203-5%201-6-1c0-3-1-3-2-3v3c0%201%200%202-2%201h-4c-2%201%201%203%204%202%202%200%203%200%203%202v4l-3%201c-2%200-3%200-2%201%200%201%201%202%202%201%202%200%203%201%203%204%200%204%200%204-3%203-2%200-3%200-3%202-1%201-1%201%203%201l4-1-1%204c0%203%200%203-2%203l-5%201c-2%201%200%201%205%201%202%200%203%200%203%202l1%203%201-2c0-2%200-2%205-3%204%200%205%200%205%202s2%204%202%201v-3h3l5-1c2-1%202-1%202%201l1%203%201-2c0-2%200-2%205-3%205%200%206%200%205%201l1%204c1%202%201%200%201-10v-5h9c2-2%203%200%202%204%200%203%200%204-3%204l-6%201%205%201c4-1%205-1%204%201l1%202c2%200%202-1%202-2-1-2-1-2%202-2l5-1-6-1c-1%200-2-1-2-4s0-4%202-3l5-1c2-1%201-1-5-1-2%200-2-1-3-4%200-3%200-3%203-3h4c2-1%201-1-4-1l-3-4c0-2%201-3%203-2l4-1c1-1%201-1-1-1h-5l-1-1c1-1%200-2-1-3h-1v10c1%202%201%202-2%202h-5c-1%201-3-1-3-4%200-2%201-2%204-2h4l-5-1c-3%200-3%200-3-3l-1-3-1%203c0%203%200%203-2%203-2-1-3%200-3%201-1%201%200%201%202%201%203-1%203-1%203%202-1%203-1%203-4%203l-3%201%204%201c2%200%203%201%203%203%201%203-2%206-4%204h-3c-3%201-3%201-3-2%200-5%200-5%202-4h1l-1-2c-3%200-3-7%200-7l2-1h-3l-2-1c1-1%200-2-1-3s-1-1-1%201v4c1%201%201%207-1%207v1c2%200%202%201%202%202v3c3%201-1%203-5%203-4-1-5-1-5-4v-4l4%201%203-1-4-1h-4l1-6c0-6-1-10-2-6M131%2038c-3%201-4%206-1%206l2-1h9c0%202%204%201%205-1h5v1c0%202%202%201%202%200%201-1%200-2-1-3v-2h-2c-1%201-2%202-4%201l-2%201c0%201%200%202-1%201l-1-2v-1l-1%201h-2c-2-1-5-2-8-1m-24%2014a544%20544%200%2000-31%205l14%207%2016%206%203-2c2-2%203-2%203-9%200-8-1-8-5-7m145%2012c-6%202-6%201-3%207s3%206%208%203c4-1%205-2%203-5l-2-4c-1-3-1-3-6-1M6%2067c0%203%202%205%203%203%200-2%200-2%202%200h1l1-1c2%202%205%202%205%201h17l2-1-2-1v-1c1-2%201-2-1-2l-2%201H9c-3-1-3-1-3%201m35%201c0%203%200%203%201%201h2c0%202%200%202%202%201h1l5%201h6l1-2%201-2%201%202%201-1h2l1%202v-2c0-3-8-4-7-1l-1%202c-1%201-1%200-1-1%200-3%200-3-7-3h-8v3m115-1c-2%203-2%203-1%206%201%202%201%204-1%208l-1%206c1%200%201%203-1%206l1%202%202-5c2-5%203-4%203%203l1%204%201-1-1-9v-4c3%207%204%205%201-2v-5l3-2%202-1%201-1-1-2-1-1v-2c-3-2-5-2-8%200m-87%205c-2%202-2%205-1%207v8h1l-4%203-4%203%203-1c3-2%204-1%203%202%200%203%201%202%203-2l1-3v3l2%205v-6l-1-4%201-1-2-3%201-2c4%200%205-8%201-10-2-1-2-1-4%201m-52%203h-2c-2%200-2%200-2%202l1%203%201-1h14c0-2%200-2%202%200h4c3%201%209%201%209-1l2-3h-3c-2-1-16-1-15%201l-1%202-1-1v-2l-1%202-1%203v-3l-1-2h-6m-4%209l-1%202h-1c0-3-5-3-5%200%200%202%201%203%203%203h8c3%200%204-1%204-2l1-2%201%202h1c1-1%201-1%201%201h8c4%202%207%200%205-3l-4-1c0%202%200%202-3%200H13m267%2073l-1%2043c-1%201%2026%201%2060%201h61v-87H280v43M1%20158v42h91v-12H79c-18-1-34%200-34%202h-1l-3-2-3%202h-1l-17-1-17-1%2010-1h25v-3a3041%203041%200%20010-10l-2-6c-3-6%204-14%208-8%201%203%201%208-1%2010l1%204c2%204%202%205%201%205l-2-3c-2-6-2-1%200%205l1%206h48v-72H1v43m280-6v37h2l13%201%2011%201h-26v9h118v-85H281v37m-95-26c-2%206%205%2019%209%2016%202-2%201-11-2-14-2-3-6-3-7-2m14%200c-1%202%203%2015%206%2017%203%201%205-3%205-8-1-6-8-13-11-9m-152%206c0%203%200%203%201%202l2-1c1%202%203%201%203-1l1%201c1%201%201%201%201-1l1-2v2c0%203%203%204%204%202h10v-1l1-2v2l2%201h8l-1-2h-2l1-2c1-1-5-1-13-1l-15%201h-1c-2-2-3-1-3%202m84%208l9%2016-1-3-1-3c1%200%207%2010%206%2011l-2-2c-2-4-3-3-1%201%201%203%203%204%205%201l3%205c4%208%204%208%200%208-4-1-4-1-11-17l-5-8%208%2019%202%206%204%201c4%200%205%200%206%204%202%204%205%206%207%204%201-1%202-4%201-5a277%20277%200%2001-6-7l-14-26h100l4%207a970%20970%200%200014%2025c-2%200-2%202%201%202%204%200%203-2-5-15l-11-16-3-4-44-1h-51c-7-1-8%200-6%205%203%205%201%205-1-1l-4-5v-2l-1-2c-3-2-3-1-3%202m-10%204l-5%201c-3%200-3%203-2%207%203%204%203%204-2%204-10%200-13%206-6%2014l2%204v4c2%203%205%203%205%200%200-2%201-1%202%202%203%206%205%207%208%205%202-2-1-12-5-13-2-1-5%200-5%203h-1c-1-4-5-9-6-8h-1c1-1%200-2-1-3v-3c1-2%202-3%207-3%206%200%207%200%207-2h1c1%201%2012%202%2012%200%200-1-4-8-5-7l1%203c3%203%202%204-2%204s-7-3-7-6c0-2%204-4%206-3h2l-4-1c-4-1-3-1%202-1s6%200%207%202l2%201c0-3-7-6-12-4m210%2014l-1%203c0%202%200%202%201%201%202-2%202-2%203%200h4c0%201%201%201%201-1%201-1%201-1%201%201h3c1%202%206%201%206-1s0-2%201%200%201%202%202%201h3c2%201%202%201%202-1s0-2%201-1c1%202%202%203%204%202h4l1-1h4c1%201%201%201%201-1l-1-2h-6c-14-1-17-1-17%201l-2%203v-2c1-3%201-3-1-3l-2%201-1%201-11-1m-19%203c-2%203-2%207-1%209v4c-2%204-4%2010-2%209l2-4c1-3%201-3%201-1l-2%208-2%207%202-4%202-5%201%205%202%206%201-2-3-15%201%201%201%202c1%200%201-3-1-7l2-1c5%200%207-9%202-12-3-3-5-3-6%200m17%209c-3%202-3%205-2%207%202%204-1%204-3%201-1-2-2-2-2-1l2%204v3l-1%205c1%204%201%204%202%202%202-4%203-4%203%201l-1%204%202-4c1-4%203-4%203-1%200%202%200%202%201%200l1-1%201%204c0%202%200%202%205%201%206%200%206%200%204-5l-3-4c-3%200-4-2-4-6l-1-3v-3c1-5-4-8-7-4m-166%200c-1%200-1%205%201%209s2%203%200-1c-2-6-1-8%202-5s4%2010%201%209l-1%201c0%202%203%201%204-1l4-2c2%200%203-1%203-2h1l12%201h27c18%201%2019%201%2019-4s2-4%205%201c3%207%202%2010-2%205l-3-2%202%204c3%203%206%202%206-2s2-4%204%200c3%203%203%202%201-3-3-5-3-7%200-6%202%200%202%200%201-2-2-2-4-1-4%204l-1%203-2-1-3-4c-3-4-6-3-6%202v2h-22l-32-1c-10%200-11-1-13-3-1-2-3-3-4-2m35%2016a1557%201557%200%2001-17%202%201918%201918%200%200117-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0410ac827bb193c12c4312ed8bc3add7/ca0a1/comics-nerd_sniping.webp 223w", "/static/0410ac827bb193c12c4312ed8bc3add7/75680/comics-nerd_sniping.webp 445w", "/static/0410ac827bb193c12c4312ed8bc3add7/ca4a8/comics-nerd_sniping.webp 740w"],
                "sizes": "(max-width: 740px) 100vw, 740px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0410ac827bb193c12c4312ed8bc3add7/e92b6/comics-nerd_sniping.png 223w", "/static/0410ac827bb193c12c4312ed8bc3add7/e66bf/comics-nerd_sniping.png 445w", "/static/0410ac827bb193c12c4312ed8bc3add7/50383/comics-nerd_sniping.png 740w"],
                "sizes": "(max-width: 740px) 100vw, 740px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0410ac827bb193c12c4312ed8bc3add7/50383/comics-nerd_sniping.png",
                "alt": "XKCD Nerd Sniping",
                "title": "XKCD Nerd Sniping",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`XKCD Nerd Sniping`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You can solve this challenge in 2 parts.`}</p>
    <ol>
      <li parentName="ol">{`fix quotes around JSX props denoted by `}<inlineCode parentName="li">{`{}`}</inlineCode></li>
      <li parentName="ol">{`fix JSX object props denoted by `}<inlineCode parentName="li">{`{{ }}`}</inlineCode></li>
    </ol>
    <p>{`Each issue falls on a different level of computational solvability. That's a bad phrasing for a 2 semester class I took in college.`}</p>
    <p>{`In computer science you have `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Finite-state_machine"
      }}>{`automata theory`}</a>{`. It teaches you the classes of approaches that can solve different classes of computational problems.`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Automata_theory"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.88789237668162%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2066c-7%202-14%209-16%2016-3%208-3%20183%200%20191%202%207%209%2014%2016%2016%208%203%20338%203%20346%200%207-2%2014-9%2016-16%203-8%203-183%200-191-2-7-9-14-16-16-8-3-339-3-346%200m0%201c-8%203-14%2011-15%2018l-1%2096c1%20101%200%2094%207%20101s-10%207%20182%207%20175%200%20182-7%207%201%207-104c0-106%200-98-7-105s10-6-180-7L27%2067m39%209c-6%202-13%209-15%2015-3%208-3%20135%200%20143%202%206%209%2013%2015%2015%208%203%20285%203%20293%200%206-2%2013-9%2015-15%203-8%203-135%200-143-2-6-9-13-15-15-8-3-286-3-293%200m1%201c-6%202-10%206-13%2011l-2%205v140l2%204c3%206%2011%2011%2016%2011l146%201h142l5-4c3-1%206-4%207-7l4-5V92l-4-5c-1-3-4-6-7-7l-5-3-144-1-147%201m39%209c-6%202-13%209-15%2015-3%208-3%2085%200%2093%202%206%209%2013%2015%2015%208%203%20230%203%20238%200%206-2%2013-9%2015-15%203-8%203-85%200-93-2-6-9-13-15-15-8-3-231-3-238%200m1%201c-6%202-10%206-13%2011l-2%205v90l3%205c1%203%204%206%207%207l5%204h236l5-4c3-1%206-4%207-7l4-5v-91l-4-5c-1-3-4-6-7-7l-5-3-116-1-120%201m39%209c-6%202-13%209-15%2015-2%204-2%209-2%2022%200%2019%201%2023%208%2030%208%208%204%208%20101%208s92%200%20100-8c7-7%208-11%208-30%200-20-1-24-8-31-8-8-3-8-101-8-76%200-87%200-91%202m1%201c-6%202-10%206-13%2011l-2%205v40l3%205c1%203%204%206%207%207l5%204h181l5-4c3-1%206-4%207-7l4-5v-41l-4-5c-1-3-4-6-7-7l-5-3-89-1-92%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a9a3d42a4f02fc46c656e163200d3f94/ca0a1/rysvgpngjj594d.webp 223w", "/static/a9a3d42a4f02fc46c656e163200d3f94/75680/rysvgpngjj594d.webp 445w", "/static/a9a3d42a4f02fc46c656e163200d3f94/8d1ba/rysvgpngjj594d.webp 890w", "/static/a9a3d42a4f02fc46c656e163200d3f94/3838e/rysvgpngjj594d.webp 1335w", "/static/a9a3d42a4f02fc46c656e163200d3f94/fad48/rysvgpngjj594d.webp 1600w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/a9a3d42a4f02fc46c656e163200d3f94/e92b6/rysvgpngjj594d.png 223w", "/static/a9a3d42a4f02fc46c656e163200d3f94/e66bf/rysvgpngjj594d.png 445w", "/static/a9a3d42a4f02fc46c656e163200d3f94/4ef49/rysvgpngjj594d.png 890w", "/static/a9a3d42a4f02fc46c656e163200d3f94/4e814/rysvgpngjj594d.png 1335w", "/static/a9a3d42a4f02fc46c656e163200d3f94/29007/rysvgpngjj594d.png 1600w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/a9a3d42a4f02fc46c656e163200d3f94/4ef49/rysvgpngjj594d.png",
              "alt": "rysvgpngjj594d",
              "title": "rysvgpngjj594d",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p>{`The other side of this coin are languages. `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Regular_language"
      }}>{`Regular languages`}</a>{`, `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Context-free_language"
      }}>{`context-free languages`}</a>{`, `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Context-sensitive_language"
      }}>{`context-sensitive languages`}</a>{`. It goes on.`}</p>
    <p>{`Math gibberish for:`}</p>
    <ul>
      <li parentName="ul">{`you can use finite state machines to parse regular languages`}</li>
      <li parentName="ul">{`you can't for context-sensitive languages`}</li>
    </ul>
    <p>{`Easiest way to know which you're facing 👉 if you have to match open/close parentheses, you're dealing with context.`}</p>
    <h2 {...{
      "id": "fix-quotes-around-"
    }}>{`Fix quotes around `}<inlineCode parentName="h2">{`{}`}</inlineCode></h2>
    <p>{`You can solve the first part by `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/1732348/regex-match-open-tags-except-xhtml-self-contained-tags/1732454#1732454"
      }}>{`summoning Cthulhu`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1296481223859146752"
      }}><img parentName="a" {...{
          "src": "/static/media/error.4c412ab4.png",
          "alt": "Click through for source"
        }}></img></a></p>
    <p>{`Here's the bit that summons Cthulhu and solves our problem:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=while%20(html.match(%2F%5C%3C(.%2B%5Cw%2B)%3D%22%5C%7B(.*)%5C%7D%22(.*)%5C%3E%2F))%20%7B%0A%20%20%20%20html%20%3D%20html.replace(%2F%5C%3C(.%2B%5Cw%2B)%3D%22%5C%7B(.*)%5C%7D%22(.*)%5C%3E%2F%2C%20%22%3C%241%3D%7B%242%7D%243%3E%22)%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "34.08071748878923%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'136\\'%20viewBox=\\'0%200%20400%20136\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2030c-3%200-4%2073-2%2077l180%201c170%200%20179%200%20180-2s0-75-1-76H22\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9e3c394901441766074967d4bd71b7ff/ca0a1/techletter.app-screenshot-1598035503830.webp 223w", "/static/9e3c394901441766074967d4bd71b7ff/75680/techletter.app-screenshot-1598035503830.webp 445w", "/static/9e3c394901441766074967d4bd71b7ff/8d1ba/techletter.app-screenshot-1598035503830.webp 890w", "/static/9e3c394901441766074967d4bd71b7ff/5c7ba/techletter.app-screenshot-1598035503830.webp 1308w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9e3c394901441766074967d4bd71b7ff/e92b6/techletter.app-screenshot-1598035503830.png 223w", "/static/9e3c394901441766074967d4bd71b7ff/e66bf/techletter.app-screenshot-1598035503830.png 445w", "/static/9e3c394901441766074967d4bd71b7ff/4ef49/techletter.app-screenshot-1598035503830.png 890w", "/static/9e3c394901441766074967d4bd71b7ff/71b12/techletter.app-screenshot-1598035503830.png 1308w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9e3c394901441766074967d4bd71b7ff/4ef49/techletter.app-screenshot-1598035503830.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This code uses regex to fix HTML even though HTML is not a regular language and is therefore not parseable by regex.`}</p>
    <p>{`Why does it work then? 🤨`}</p>
    <p>{`It works because it doesn't rely on matching open/close tags. Looks like it does, but it doesn't.`}</p>
    <p>{`This part here `}<inlineCode parentName="p">{`/\\<(.+\\w+)="\\{(.*)\\}"(.*)\\>/`}</inlineCode>{` asks for: `}<em parentName="p">{`"Give me any pair of `}<inlineCode parentName="em">{`"{ }"`}</inlineCode>{`, matched or not, that appears between any pair of `}<inlineCode parentName="em">{`<>`}</inlineCode>{`, matched or not`}</em></p>
    <p>{`The regex returns 3 matched groups:`}</p>
    <ol>
      <li parentName="ol">{`everything before the pair`}</li>
      <li parentName="ol">{`everything inside the pair`}</li>
      <li parentName="ol">{`everything after the pair`}</li>
    </ol>
    <p>{`We use those groups to replace with a fixed string:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=html%20%3D%20html.replace(...%2C%20%22%3C%241%3D%7B%242%7D%243%3E%22)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "844px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "43.946188340807176%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'176\\'%20viewBox=\\'0%200%20400%20176\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2047c-2%202-2%203-2%2042l1%2042c3%203%20335%203%20338%200l1-42c0-39%200-40-2-42-3-3-333-3-336%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/19ed9e67368ba8518c0adcf6759d9c50/ca0a1/techletter.app-screenshot-1598035504022.webp 223w", "/static/19ed9e67368ba8518c0adcf6759d9c50/75680/techletter.app-screenshot-1598035504022.webp 445w", "/static/19ed9e67368ba8518c0adcf6759d9c50/20d15/techletter.app-screenshot-1598035504022.webp 844w"],
                "sizes": "(max-width: 844px) 100vw, 844px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/19ed9e67368ba8518c0adcf6759d9c50/e92b6/techletter.app-screenshot-1598035504022.png 223w", "/static/19ed9e67368ba8518c0adcf6759d9c50/e66bf/techletter.app-screenshot-1598035504022.png 445w", "/static/19ed9e67368ba8518c0adcf6759d9c50/33e10/techletter.app-screenshot-1598035504022.png 844w"],
                "sizes": "(max-width: 844px) 100vw, 844px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/19ed9e67368ba8518c0adcf6759d9c50/33e10/techletter.app-screenshot-1598035504022.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Open `}<inlineCode parentName="p">{`<`}</inlineCode>{`, first group, `}<inlineCode parentName="p">{`={`}</inlineCode>{`, second group, `}<inlineCode parentName="p">{`}`}</inlineCode>{`, third group, close `}<inlineCode parentName="p">{`>`}</inlineCode>{`. Then repeat in a loop until no more candidates are found.`}</p>
    <p>{`Matching never matters and that's why this works.`}</p>
    <p><img parentName="p" {...{
        "src": "/9a021a6cd72cfaab539f3b1fef648ed9/media-12NUbkX6p4xOO4-giphy.gif",
        "alt": "magic giphy"
      }}></img></p>
    <h2 {...{
      "id": "fix-broken---props"
    }}>{`Fix broken `}<inlineCode parentName="h2">{`{{ }}`}</inlineCode>{` props`}</h2>
    <p>{`The broken object props are harder. Here you `}<em parentName="p">{`are`}</em>{` dealing with a contextual language – you have to match the open `}<inlineCode parentName="p">{`{{`}</inlineCode>{` to its nearest closing `}<inlineCode parentName="p">{`}}`}</inlineCode>{`.`}</p>
    <p>{`If you don't, you'll get the wrong result.`}</p>
    <p>{`That means you have to solve this one `}<em parentName="p">{`before`}</em>{` stringification. When you still have access to the underlying AST.`}</p>
    <p>{`My idea was to iterate through the props and collect them into a new object. When you hit `}<inlineCode parentName="p">{`{{`}</inlineCode>{`, start collecting values into a new prop, add to new object as full prop when you hit `}<inlineCode parentName="p">{`}}`}</inlineCode>{`.`}</p>
    <p>{`Here's how:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=function%20fixJsxObjectProps(tree)%20%7B%0A%20%20%20%20if%20(tree.type%20%3D%3D%3D%20%22element%22%20%26%26%20tree.properties)%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20bad%20props%20start%20with%20a%20broken%20prop%3D'%7B%7B'%0A%20%20%20%20%20%20%20%20if%20(Object.values(tree.properties).some((val)%20%3D%3E%20val%20%3D%3D%3D%20%22%7B%7B%22))%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20loop%20through%20props%20to%20fix%0A%0A%20%20%20%20%20%20%20%20%20%20%20%20tree.properties%20%3D%20Object.fromEntries(props)%3B%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%0A%20%20%20%20if%20(tree.children)%20%7B%0A%20%20%20%20%20%20%20%20tree.children%20%3D%20tree.children.map(fixJsxObjectProps)%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20return%20tree%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "69.05829596412556%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'276\\'%20viewBox=\\'0%200%20400%20276\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2029v111l1%20109h361V29l-181-1-181%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6a54b2470759290c54fdf955ca32d413/ca0a1/techletter.app-screenshot-1598035504431.webp 223w", "/static/6a54b2470759290c54fdf955ca32d413/75680/techletter.app-screenshot-1598035504431.webp 445w", "/static/6a54b2470759290c54fdf955ca32d413/8d1ba/techletter.app-screenshot-1598035504431.webp 890w", "/static/6a54b2470759290c54fdf955ca32d413/3838e/techletter.app-screenshot-1598035504431.webp 1335w", "/static/6a54b2470759290c54fdf955ca32d413/1177a/techletter.app-screenshot-1598035504431.webp 1372w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6a54b2470759290c54fdf955ca32d413/e92b6/techletter.app-screenshot-1598035504431.png 223w", "/static/6a54b2470759290c54fdf955ca32d413/e66bf/techletter.app-screenshot-1598035504431.png 445w", "/static/6a54b2470759290c54fdf955ca32d413/4ef49/techletter.app-screenshot-1598035504431.png 890w", "/static/6a54b2470759290c54fdf955ca32d413/4e814/techletter.app-screenshot-1598035504431.png 1335w", "/static/6a54b2470759290c54fdf955ca32d413/b79a5/techletter.app-screenshot-1598035504431.png 1372w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6a54b2470759290c54fdf955ca32d413/4ef49/techletter.app-screenshot-1598035504431.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This code sets up a method that recursively visits all children in a tree. Makes it useful in a more general case.`}</p>
    <p>{`Start the algorithm if you encounter an element with `}<inlineCode parentName="p">{`{{`}</inlineCode>{` in its properties.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=let%20props%20%3D%20%5B%5D%3B%0Alet%20collecting%20%3D%20false%3B%0Alet%20prop%2C%20propVal%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%0Afor%20(let%20%5Bkey%2C%20val%5D%20of%20Object.entries(tree.properties))%20%7B%0A%20%20%20%20if%20(val%20%3D%3D%3D%20%22%7B%7B%22)%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20the%20next%20several%20props%20are%20part%20of%20the%20object%0A%20%20%20%20%20%20%20%20collecting%20%3D%20true%3B%0A%20%20%20%20%20%20%20%20prop%20%3D%20key%3B%0A%20%20%20%20%20%20%20%20propVal%20%3D%20%5Bval%5D%3B%0A%20%20%20%20%7D%20else%20if%20(collecting)%20%7B%0A%20%20%20%20%20%20%20%20%2F%2F%20collect%20props%0A%20%20%20%20%20%20%20%20propVal.push(%60%24%7Bkey%7D%20%24%7Bval%7D%60)%3B%0A%0A%20%20%20%20%20%20%20%20if%20(key.includes(%22%7D%7D%22)%20%7C%7C%20val.includes(%22%7D%7D%22))%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%2F%2F%20stop%20collecting%20when%20done%0A%20%20%20%20%20%20%20%20%20%20%20%20props.push(%5B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20prop%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20propVal%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.join(%22%20%22)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.replace(%2F%5B%20%5D%7B2%2C%7D%2Fg%2C%20%22%20%22)%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20.trim()%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%5D)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20collecting%20%3D%20false%3B%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%20else%20%7B%0A%20%20%20%20%20%20%20%20props.push(%5Bkey%2C%20val%5D)%3B%0A%20%20%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "123.76681614349776%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'495\\'%20viewBox=\\'0%200%20400%20495\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2036c-2%201-1%20423%200%20425%202%202%20350%202%20352%200l1-214V36l-177-1-176%201M0%20481v14h401v-28H0v14\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3e14979906b3acfbf21c94d9b2abfa3b/ca0a1/techletter.app-screenshot-1598035504297.webp 223w", "/static/3e14979906b3acfbf21c94d9b2abfa3b/75680/techletter.app-screenshot-1598035504297.webp 445w", "/static/3e14979906b3acfbf21c94d9b2abfa3b/8d1ba/techletter.app-screenshot-1598035504297.webp 890w", "/static/3e14979906b3acfbf21c94d9b2abfa3b/36c36/techletter.app-screenshot-1598035504297.webp 1116w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3e14979906b3acfbf21c94d9b2abfa3b/e92b6/techletter.app-screenshot-1598035504297.png 223w", "/static/3e14979906b3acfbf21c94d9b2abfa3b/e66bf/techletter.app-screenshot-1598035504297.png 445w", "/static/3e14979906b3acfbf21c94d9b2abfa3b/4ef49/techletter.app-screenshot-1598035504297.png 890w", "/static/3e14979906b3acfbf21c94d9b2abfa3b/ea64c/techletter.app-screenshot-1598035504297.png 1116w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3e14979906b3acfbf21c94d9b2abfa3b/4ef49/techletter.app-screenshot-1598035504297.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Prep a value for new props, a flag that says when you're collecting, and 2 variables to collect into.`}</p>
    <p>{`Then you iterate and:`}</p>
    <ul>
      <li parentName="ul">{`if `}<inlineCode parentName="li">{`{{`}</inlineCode>{` is encountered, start collecting`}</li>
      <li parentName="ul">{`if you're collecting, add values to the current prop`}</li>
      <li parentName="ul">{`if `}<inlineCode parentName="li">{`}}`}</inlineCode>{` is encountered, stop collecting and create a new prop`}</li>
      <li parentName="ul">{`push unchanged prop to new object normally`}</li>
    </ul>
    <p>{`Final `}<inlineCode parentName="p">{`Object.fromEntries`}</inlineCode>{` call takes the generated array of `}<inlineCode parentName="p">{`[key, value]`}</inlineCode>{` pairs and turns them into a properties object.`}</p>
    <p>{`Upon stringification, this gets wrapped in `}<inlineCode parentName="p">{`"`}</inlineCode>{` quotes, but the Cthulhu summoning code fixes that.`}</p>
    <p>{`And you get the correct result. Here's a codesandbox for proof`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/happy-snowflake-97sp7"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h71v-9h96l1%205%202%204%201-98V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2169ef2054c18689b04392c7c2c2f6e6/ca0a1/techletter.app-screenshot-1598035520936.webp 223w", "/static/2169ef2054c18689b04392c7c2c2f6e6/75680/techletter.app-screenshot-1598035520936.webp 445w", "/static/2169ef2054c18689b04392c7c2c2f6e6/8d1ba/techletter.app-screenshot-1598035520936.webp 890w", "/static/2169ef2054c18689b04392c7c2c2f6e6/3838e/techletter.app-screenshot-1598035520936.webp 1335w", "/static/2169ef2054c18689b04392c7c2c2f6e6/e11e5/techletter.app-screenshot-1598035520936.webp 1780w", "/static/2169ef2054c18689b04392c7c2c2f6e6/0a0f4/techletter.app-screenshot-1598035520936.webp 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2169ef2054c18689b04392c7c2c2f6e6/e92b6/techletter.app-screenshot-1598035520936.png 223w", "/static/2169ef2054c18689b04392c7c2c2f6e6/e66bf/techletter.app-screenshot-1598035520936.png 445w", "/static/2169ef2054c18689b04392c7c2c2f6e6/4ef49/techletter.app-screenshot-1598035520936.png 890w", "/static/2169ef2054c18689b04392c7c2c2f6e6/4e814/techletter.app-screenshot-1598035520936.png 1335w", "/static/2169ef2054c18689b04392c7c2c2f6e6/701e9/techletter.app-screenshot-1598035520936.png 1780w", "/static/2169ef2054c18689b04392c7c2c2f6e6/bb052/techletter.app-screenshot-1598035520936.png 3722w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2169ef2054c18689b04392c7c2c2f6e6/4ef49/techletter.app-screenshot-1598035520936.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you thought computer science was useless in web development. Ha!`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      